import { mossoParams } from './../store/mosso'
import { reportToPtt } from './../request/mosso'
import { getHtmlDocName } from './../utils/index'

/**
 * 对vue-router进行路由注入
 * @param {Object} router 
 */
export default function regRouter(router) {
	router.beforeEach((to, from, next) => {
		const toPath = to.path                       // 会包含url参数等信息
		let routerPath = toPath.match(/([^?]+)\??/)  // 获取router

		if (!mossoParams.path) {
			mossoParams.path = location.pathname.replace(getHtmlDocName(),'')
		}
		
		// 上报数据到点击流（ptt统计）
		let tcssRouterPath = routerPath && routerPath[1] ? (mossoParams.path + routerPath[1]).replace('//','/'): 'router not find'
		// 
		reportToPtt({
			//pageType: to.meta.tcssConf.pageType,
			//pageName: to.meta.tcssConf.pageType,
			meta: to.meta,
			name: to.name,
			path: tcssRouterPath
		})

		next()
	})
}